// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"100":"48866037","239":"643364a8","396":"7241f297","453":"6768abf3","455":"4ae1afb0","600":"51e00ae0"}[chunkId] + ".chunk.js";
};